import { render, staticRenderFns } from "./CommentListCreateEdit.vue?vue&type=template&id=60cbd4a3&scoped=true&"
import script from "./CommentListCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CommentListCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommentListCreateEdit.vue?vue&type=style&index=0&id=60cbd4a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cbd4a3",
  null
  
)

export default component.exports